import React from "react";
import { Box, Typography } from "@mui/material";

interface LegendItemProps {
  label: string;
  value: number | string;
  dotColor: string;
}

const getLegendItem = ({ label, value, dotColor }: LegendItemProps) => (
  <Box
    sx={{
      fontSize: "14px",
      color: "rgba(0, 0, 0, 0.6)",
      display: "flex",
      alignItems: "center",
      marginTop: "4px",
    }}
  >
    <Box
      sx={{
        width: "8px",
        height: "8px",
        backgroundColor: dotColor,
        marginRight: "8px",
        borderRadius: "50%",
      }}
    />
    {label}:{" "}
    <span style={{ color: "#000000", marginLeft: "4px" }}>
      {typeof value === "number" ? Math.round(value) : value}
    </span>
  </Box>
);

interface SgipGraphLegendProps {
  date?: string;
  primaryLabel: string;
  primaryValue: number | string;
  targetLabel?: string;
  targetValue?: number | string;
  previousYearLabel?: string;
  previousYearValue?: number | string;
  title?: string;
}

const SgipGraphLegend: React.FC<SgipGraphLegendProps> = ({
  date,
  primaryLabel,
  primaryValue,
  targetLabel,
  targetValue,
  previousYearLabel,
  previousYearValue,
  title,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "12px",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: "4px",
      }}
    >
      {date && <Box sx={{ fontSize: "14px", fontWeight: "500", marginBottom: "4px" }}>{date}</Box>}
      <Typography variant="subtitle2">{title}</Typography>
      {getLegendItem({ label: primaryLabel, value: primaryValue, dotColor: "#000000" })}
      {targetLabel &&
        targetValue !== undefined &&
        getLegendItem({
          label: targetLabel,
          value: targetValue,
          dotColor: "rgba(46, 125, 50, 0.5)",
        })}
      {previousYearLabel &&
        previousYearValue !== undefined &&
        getLegendItem({
          label: previousYearLabel,
          value: previousYearValue,
          dotColor: "rgba(189, 189, 189, 1)",
        })}
    </Box>
  );
};

export default SgipGraphLegend;
